import { Component, OnInit } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { SharedStateService } from 'src/app/services/shared-state.service';


@Component({
  selector: 'apg-beat-your-broker-header',
  templateUrl: './apg-beat-your-broker-header.component.html',
  styleUrls: ['./apg-beat-your-broker-header.component.scss'],
})
export class ApgBeatYourBrokerHeaderComponent implements OnInit {
  private lastState: QQQuestionnaireViewModel = null;

  progress$: Observable<{ step: string, complete: boolean }[]>;

  constructor(private sharedStateService: SharedStateService<QQQuestionnaireViewModel>) { 
  }
  
  ngOnInit() {
    this.sharedStateService.currentState$.subscribe(current => {
      if (current)
        this.updateData(current);
    });
  }

  updateData(updatedState: QQQuestionnaireViewModel) {
      this.lastState = updatedState; 
      this.progress$ = this.lastState.visiblePages$.pipe(
        map(pages => this.mapSteps(pages, this.lastState.currentPage))
      );
  }

  mapSteps(pages: QQQuestionnairePageViewModel[], currentPage: QQQuestionnairePageViewModel) {
    let lastStep: { step: string, complete: boolean } = null;
    let complete = true;

    return pages.reduce((acc, page) => {
      if (!lastStep || (page.step && page.step !== lastStep.step)) {
        lastStep = { step: page.step, complete };
        acc.push(lastStep);
      }

      if (complete && page === currentPage)
        complete = false;

      return acc;
    }, []);
  }

}
